import { render, staticRenderFns } from "./SSNotificationsView.vue?vue&type=template&id=5fc11617&scoped=true&"
import script from "./SSNotificationsView.vue?vue&type=script&lang=js&"
export * from "./SSNotificationsView.vue?vue&type=script&lang=js&"
import style0 from "./SSNotificationsView.vue?vue&type=style&index=0&id=5fc11617&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc11617",
  null
  
)

export default component.exports